import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AuthCallback from "@/components/AuthCallback";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import GoalSetting from "@/pages/GoalSetting";
import Telecalling from "@/pages/Telecalling";
import Counselling from "@/pages/Counselling";
import BusinessDevelopment from "@/pages/BusinessDevelopment";
import Marketing from "@/pages/Marketing";
import Batches from "@/pages/Batches";
import Finance from "@/pages/Finance";
import Reviews from "@/pages/Reviews";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center bg-navy">
        <div className="h-10 w-10 rounded-full border-2 border-gold border-t-transparent animate-spin" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/goals" element={<GoalSetting />} />
        <Route path="/telecalling" element={<Telecalling />} />
        <Route path="/counselling" element={<Counselling />} />
        <Route path="/business-development" element={<BusinessDevelopment />} />
        <Route path="/marketing" element={<Marketing />} />
        <Route path="/batches" element={<Batches />} />
        <Route path="/finance" element={<Finance />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
